export default __webpack_public_path__ + "static/media/screen.977d3aa2.svg";